import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormularioRentaComponent } from './formulario-renta/formulario-renta.component';

@Component({
  selector: 'app-listado-rentas',
  templateUrl: './listado-rentas.component.html',
  styleUrls: ['./listado-rentas.component.scss']
})
export class ListadoRentasComponent implements OnInit {
    

    public renta: any= {
        intereses_moratorios: [],
        incremento_inpc: false,
        activo: true,
        periodicidad: "MENSUAL"
    };
    public loading:boolean = false;
    public errors:any=[];
    
    @Input() public contrato: any = {};

    @ViewChild(FormularioRentaComponent) formulario_renta:FormularioRentaComponent;
    @Output() contratoGuardado: EventEmitter<any> = new EventEmitter;

    constructor() {
    }

    ngOnInit() {
    }

    defaultRenta(){
        return {
            intereses_moratorios: [],
            incremento_inpc: false,
            activo: true,
            periodicidad: "MENSUAL"
        };
    }

    loadRenta(renta){
        this.renta = renta;
        var parent = this;
        setTimeout(function(){
            parent.formulario_renta.loadRenta(renta);
        },500);
    }

    guardarRenta($event){
        var renta_recibida = $event;
        if(renta_recibida.id_renta && renta_recibida.id_renta!=0){
            for(var i=0;i<this.contrato.rentas.length;i++){
                var r = this.contrato.rentas[i];
                if(r.id_renta==renta_recibida.id_renta){
                    this.contrato.rentas[i] = renta_recibida;
                }
            }
        }else{
            this.contrato.rentas.push($event);
        }
        this.guardarContrato(false);
    }

    validar(){
        var valid = true;
        this.errors = [];
        if(this.contrato.rentas.length==0){
            valid = false;
            this.errors['rentas']="Por favor dé de alta una o más rentas";
        }
        return valid;
    }

    guardarContrato(go_to_next_page){
        if(!this.validar()) return false;
        this.loading = true;
        var parent = this;
        if(this.contratoGuardado){
          this.contratoGuardado.emit(
              {
                  go_to_next_page:go_to_next_page, 
                  contrato:this.contrato,
                  callback: function(){
                    parent.loading = false;
                    parent.nuevaRenta();
                  }
                });
        }
      }

    nuevaRenta(){
        this.renta = this.defaultRenta();
        var parent = this;
        setTimeout(function(){
            parent.formulario_renta.loadRenta(parent.renta);
        },500);
    }

    eliminarRenta(index){
        if(confirm("¿Estás seguro que deseas eliminar esta renta?")){
            for(var i=0;i<this.contrato.rentas.length;i++){
                if(index==i){
                    this.contrato.rentas.splice(i,1);
                }
            }
            this.guardarContrato(false); 
        }
    }

    loadContrato(){
        var parent = this;
        setTimeout(function(){
            parent.formulario_renta.loadContrato();
        },500);
    }

    public mostrarErroresEnGuardado(repuestaServicio){

        if(repuestaServicio && repuestaServicio.content){
            let content = repuestaServicio.content;
            
            if(content.fecha_inicio){
                this.errors['rentas']= content.fecha_inicio;
            }

            if(content.fecha_fin){
                this.errors['rentas']= content.fecha_fin;
            }
        }
    }

    
}


// WEBPACK FOOTER //
// ./src/app/components/contratos/agregar-contrato/listado-rentas/listado-rentas.component.ts